import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('For You')

/** 👇 View For You */
const ViewForYou = () => analytics({
  label: GenerateLabel({ label: 'foryou' }),
  action: 'foryou - view',
  name: 'view_fy',
});

/** 👇 Users Click For You content */
const ClickForYou = ({
  contentTitle = '',
  contentType = '',
}) => analytics({
  label: GenerateLabel({ label: 'foryou', contentTitle, contentType }),
  action: 'foryou - click artikel', name: 'click_fy',
});

const ForYou = { ViewForYou, ClickForYou };

export default ForYou;
